import type { VehicleDriverDto } from '@cobliteam/api-lib/src/__generated__/graphql';
import { useTranslation } from '@cobliteam/i18n';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';

interface AssociationDriverChangeProps {
  previousDriver?: VehicleDriverDto | null;
  currentDriver?: VehicleDriverDto | null;
}

const AssociationDriverChange = ({ previousDriver, currentDriver }: AssociationDriverChangeProps) => {
  const { t } = useTranslation('path-association');

  return (
    <div className='flex w-full items-center gap-1'>
      <div className='rounded-lg bg-gray-2 px-2 py-1 line-through'>
        <Typography variant='text-md' color='secondary'>
          {previousDriver?.name || t('association_history.no_driver')}
        </Typography>
      </div>
      <Icon name='arrow-right' color='gray-dark' />
      <div className='rounded-lg bg-gray-2 px-2 py-1'>
        <Typography variant='text-md' color='secondary'>
          {currentDriver?.name || t('association_history.no_driver')}
        </Typography>
      </div>
    </div>
  );
};

export default AssociationDriverChange;
